module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-16-min.82714566.jpg";